import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";
import $ from "jquery";
import { default as React, useEffect, useRef, useState } from "react";
import SignaturePad from "react-signature-canvas";
import config from "../../contexts/config";
import "../arajanlatozo/arajanlatozo.scss";
import arak from "../arajanlatozo/arak.json";
import employees from "../bejelentkezes/0ae127cd7614241e3a8527b0fa1a1900.json";
import OtthonFelujitas from "../otthonfelujitas/otthonfelujitas";
import "../solar/solar-model.scss";

const style = {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
};

const DokumentumKitolto = () => {
  const [formData, setFormData] = useState({
    bekuldeniId: "",
    nev: "",
    lakcim: "",
    szuletesihely: "",
    szuletesiido: null,
    anyjaneve: "",
    adoazonosito: "",
    napelemtipus: "",
    napelemdarab: 0,
    inverterdarab: 0,
    invertertipus: "",
    akkumulatortipus: "",
    akkumulatordarab: 0,
    bruttovallalkozoidij: "",
    eloleg: "",
    ertekesito: "",
    NevlegesTeljesitmeny: 0.0,
    nettovallalkozoidij: 0,
    afa: 0,
    elolegnetto: 0,
    elolegafa: 0,
    elolegbrutto: 0,
    garanciak: [],
    telefonszam: "",
    email: "",
    ertekesitonev: "",
    ertekesitoemail: "",
    ertekesitotelefonszam: "",
    keltezesdatuma: new Date(), // Default value set to today's date
    keltezesvaros: "",
    selectedKey: "",
    Id: "",
    ContactId: "",
    TelepitesiIranyitoszam: "",
    TelepitesiCim: "",
    TelepitesiUtcahazszam: "",
    akkumulatorAtveszem: false,
    napelemAtveszem: false,
    alairas: "",
  });

  const defaultFormData = {
    bekuldeniId: "",
    nev: "",
    lakcim: "",
    szuletesihely: "",
    szuletesiido: null,
    anyjaneve: "",
    adoazonosito: "",
    napelemtipus: "",
    napelemdarab: 0,
    inverterdarab: 0,
    invertertipus: "",
    akkumulatortipus: "",
    akkumulatordarab: 0,
    bruttovallalkozoidij: "",
    eloleg: "",
    ertekesito: "",
    NevlegesTeljesitmeny: 0.0,
    nettovallalkozoidij: 0,
    afa: 0,
    elolegnetto: 0,
    elolegafa: 0,
    elolegbrutto: 0,
    garanciak: [],
    telefonszam: "",
    email: "",
    ertekesitonev: "",
    ertekesitoemail: "",
    ertekesitotelefonszam: "",
    keltezesdatuma: new Date(), // Default value set to today's date
    keltezesvaros: "",
    selectedKey: "",
    Id: "",
    ContactId: "",
    TelepitesiIranyitoszam: "",
    TelepitesiCim: "",
    TelepitesiUtcahazszam: "",
    akkumulatorAtveszem: false,
    napelemAtveszem: false,
    alairas: "",
  };

  const [selectedJson, setSelectedJson] = React.useState("vallalkozasi");

  const [isLoading, setLoading] = useState(false);
  const [isMainButtonLoading, setMainButtonLoading] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const [isError, setError] = useState(false);
  const [nevOptions, setNevOptions] = useState([]);
  const [kitoltotteId, setKitoltotteId] = React.useState(false);
  const [kitoltotteNev, setKitoltotteNev] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [currentScreen, setCurrentScreen] = useState(1);
  const sigCanvas = useRef({});
  const [trimmedDataURL, setTrimmedDataURL] = useState(null);
  const [vanAlairas, setVanAlairas] = useState(false);

  const clearSigpad = () => {
    sigCanvas.current.clear();
  };
  const trimSigpad = () => {
    setTrimmedDataURL(sigCanvas.current.getTrimmedCanvas().toDataURL());
  };

  const handleOpen = (e) => {
    e.preventDefault();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setCurrentScreen(1); // Reset to the first screen when closing
  };

  const handleFinish = () => {
    trimSigpad();
    setFormData((prev) => ({
      ...prev,
      alairas: sigCanvas.current.getTrimmedCanvas().toDataURL(),
    }));
    if (sigCanvas.current.getTrimmedCanvas().toDataURL().length > 12) {
      setVanAlairas(true);
    }
    handleClose();
  };

  const handleNext = () => setCurrentScreen(2);
  const handleBack = () => setCurrentScreen(1);

  useEffect(() => {
    let timer;
    if (isSuccess || isError) {
      timer = setTimeout(() => {
        setLoading(false);
        setSuccess(false);
        setError(false);
      }, 5000);
    }
    return () => clearTimeout(timer);
  }, [isSuccess, isError]);

  const handleJsonChange = (event) => {
    setFormData(defaultFormData);
    setKitoltotteId(false);
    setKitoltotteNev(false);
    const selectedValue = event.target.value;
    setSelectedJson(selectedValue);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "Id") {
      setKitoltotteId(value !== "");
    } else if (name === "nev") {
      setKitoltotteNev(value !== "");
    }
    if (name === "nev" && nevOptions.length > 0) {
      const selectedOption = nevOptions.find((option) => option.Name === value);
      setFormData({
        ...formData,
        nev: value,
        telefonszam: selectedOption ? selectedOption.Phone : "",
        email: selectedOption ? selectedOption.Email : "",
        selectedKey: selectedOption ? selectedOption.Id : "",
      });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleDateChange = (name, date) => {
    setFormData({ ...formData, [name]: date });
  };

  const isButtonDisabled =
    !formData.nev && !formData.telefonszam && !formData.email && !formData.Id;

  const handleSubmitAtadas = (e) => {
    e.preventDefault();
    setLoading(true);
    setMainButtonLoading(true);
    setSuccess(false);
    setError(false);
    console.log(formData);

    const ertekesito = JSON.parse(formData.ertekesito);

    // Update the state with the new values using a functional update
    setFormData((prevFormData) => ({
      ...prevFormData,
      ertekesitonev: ertekesito.name,
      ertekesitotelefonszam: ertekesito.telefonszam,
      ertekesitoemail: ertekesito.email,
    }));

    const formattedKeltezesdatuma = formData.keltezesdatuma
      ? format(formData.keltezesdatuma, "yyyy.MM.dd")
      : "";

    const formattedSzuletesiido = formData.szuletesiido
      ? format(formData.szuletesiido, "yyyy.MM.dd")
      : "";

    const termekek = [];
    let inverterGarancia = "";
    let akkumulatorGarancia = "";
    let napelemGarancia = "";
    if (formData.napelemdarab > 0) {
      termekek.push({
        nev: formData.napelemtipus.split(" ")[0],
        darab: formData.napelemdarab,
      });
      napelemGarancia = formData.napelemtipus.split(" ")[0];
    }
    if (formData.inverterdarab > 0) {
      termekek.push({
        nev: formData.invertertipus.split(" ")[0],
        darab: formData.inverterdarab,
      });
      inverterGarancia = formData.invertertipus.split(" ")[0];
    }
    if (formData.akkumulatordarab > 0) {
      termekek.push({
        nev: formData.akkumulatortipus.split(" ")[0],
        darab: formData.akkumulatordarab,
      });
      akkumulatorGarancia = formData.akkumulatortipus.split(" ")[0];
    }

    let cegalairas =
      "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";

    $.ajax({
      url: `${config.API_URL_ONRENDER}/order-number/contract`,
      type: "get",
      headers: {
        accept: "application/json",
        Authorization: `Bearer ${localStorage.token}`,
        "Content-Type": "application/json",
      },
      success: function (orderNum) {
        const formattedNumber = `GREEN-${(orderNum.number + 100)
          .toString()
          .padStart(5, "0")}`;
        const jsonData = {
          template_id: "fglXKWVkMuLV6wstPRAX",
          data: {
            NevlegesTeljesitmeny: formData.NevlegesTeljesitmeny,
            sorszam: formattedNumber,
            telepiteshelye:
              formData.TelepitesiIranyitoszam +
              ", " +
              formData.TelepitesiCim +
              " " +
              formData.TelepitesiUtcahazszam,
            nev: formData.nev,
            lakcim: formData.lakcim,
            email: formData.email,
            datum: formattedKeltezesdatuma,
            termekek,
            inverterGarancia,
            akkumulatorGarancia,
            napelemGarancia,
            napelemAtveszem: formData.napelemAtveszem,
            akkumulatorAtveszem: formData.akkumulatorAtveszem,
            keltezesVarosa: formData.keltezesvaros,
            alairas: formData.alairas,
            cegalairas: `data:image/jpeg;base64,${cegalairas}`,
            szuletesiHely: formData.szuletesihely,
            szuletesiIdo: formattedSzuletesiido,
            anyjaNeve: formData.anyjaneve,
          },
          file: "",
          sheet: "",
          name: "",
          output_name:
            formData.nev !== "" && formData.nev != null
              ? formData.nev
              : "atadas_atvet",
          output_format: ".pdf",
          output_quality: 100,
          single_file: true,
          page_break: true,
          merge_with: "",
        };
        fetch("https://api.docugenerate.com/v1/document", {
          method: "POST",
          headers: {
            accept: "application/json",
            Authorization: "945c5c49b7f73ff286550a920c167eba",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(jsonData),
        })
          .then((response) => response.json())
          .then((data) => {
            if (downloadDocument) {
              window.location.href = data.document_uri;
            }
            const documentUri = data.document_uri;
            setLoading(true);
            setMainButtonLoading(true);
            setSuccess(false);
            setError(false);

            const params = new URLSearchParams({
              id: formData.bekuldeniId,
            });

            const requestBody = {
              Atadasatveteli: documentUri,
              StatusId: 3545,
            };

            fetch(
              `${
                config.API_URL_ONRENDER
              }/minicrm/uploadFile?${params.toString()}`,
              {
                method: "PUT",
                headers: {
                  accept: "application/json",
                  Authorization: `Bearer ${localStorage.token}`,
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
              }
            )
              .then((response) => {
                if (!response.ok) {
                  return response.json().then((error) => {
                    throw new Error(error.message || "Unknown error");
                  });
                }
                return response.json();
              })
              .then(() => {
                setSuccess(true);
                setLoading(false);
                setMainButtonLoading(false);
              })
              .catch((error) => {
                setError(true);
                setLoading(false);
                setMainButtonLoading(false);
                console.error("Error:", error);
              });
          })
          .catch((error) => {
            setError(true);
            setLoading(false);
            setMainButtonLoading(false);
            console.error("Error:", error);
          });
      },
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setMainButtonLoading(true);
    setSuccess(false);
    setError(false);

    const wattString = formData.napelemtipus.split(" ").pop();
    const wattValue = wattString.endsWith("W")
      ? wattString.slice(0, -1)
      : wattString;
    const nevlegesteljesitmeny = parseInt(wattValue) * formData.napelemdarab;
    const nettovallalkozoidij = Math.round(
      formData.bruttovallalkozoidij / 1.27
    );
    const afa = Math.round(formData.bruttovallalkozoidij - nettovallalkozoidij);
    const elolegnetto = Math.round(
      (formData.eloleg / 100) * nettovallalkozoidij
    );
    const elolegbrutto = Math.round(
      (formData.eloleg / 100) * formData.bruttovallalkozoidij
    );
    const elolegafa = Math.round(elolegbrutto - elolegnetto);

    // Create a copy of the current garanciak array
    const newGaranciak = [];

    // Conditionally push items into the newGaranciak array
    if (formData.napelemdarab > 0) {
      newGaranciak.push({
        tipus: "Napelem",
        garancia: "15 év teljeskörű, gyártó által biztosított garancia",
      });
      newGaranciak.push({
        tipus: "",
        garancia: "25 év 80% teljesítménygarancia (gyártói)",
      });
    }
    if (formData.inverterdarab > 0) {
      newGaranciak.push({
        tipus: "Inverter",
        garancia: "5 év teljeskörű, gyártó által biztosított garancia",
      });
    }
    if (formData.akkumulatordarab > 0) {
      newGaranciak.push({
        tipus: "Akkumulátor",
        garancia: "5 év teljeskörű, gyártó által biztosított garancia",
      });
    }

    const ertekesito = JSON.parse(formData.ertekesito);

    // Update the state with the new values using a functional update
    setFormData((prevFormData) => ({
      ...prevFormData,
      nettovallalkozoidij,
      afa,
      elolegnetto,
      elolegbrutto,
      elolegafa,
      garanciak: [...newGaranciak],
      ertekesitonev: ertekesito.name,
      ertekesitotelefonszam: ertekesito.telefonszam,
      ertekesitoemail: ertekesito.email,
    }));

    const formattedSzuletesiido = formData.szuletesiido
      ? format(formData.szuletesiido, "yyyy.MM.dd")
      : "";
    const formattedKeltezesdatuma = formData.keltezesdatuma
      ? format(formData.keltezesdatuma, "yyyy.MM.dd")
      : "";

    function arformazo(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    $.ajax({
      url: `${config.API_URL_ONRENDER}/order-number/contract`,
      type: "get",
      headers: {
        accept: "application/json",
        Authorization: `Bearer ${localStorage.token}`,
        "Content-Type": "application/json",
      },
      success: function (orderNum) {
        const formattedNumber = `GREEN-${(orderNum.number + 100)
          .toString()
          .padStart(5, "0")}`;
        const jsonData = {
          template_id: "bZVHnGw5z5GbU9UK7Gyc",
          data: {
            nev: formData.nev,
            sorszam: formattedNumber,
            lakcim: formData.lakcim,
            szuletesihely: formData.szuletesihely,
            szuletesiido: formattedSzuletesiido,
            anyjaneve: formData.anyjaneve,
            adoazonosito: formData.adoazonosito,
            napelemdarab: formData.napelemdarab,
            napelemtipus: formData.napelemtipus,
            inverterdarab: formData.inverterdarab,
            invertertipus: formData.invertertipus,
            akkumulatordarab: formData.akkumulatordarab,
            akkumulatortipus: formData.akkumulatortipus,
            nevlegesteljesitmeny: nevlegesteljesitmeny,
            telepiteshelye:
              formData.TelepitesiIranyitoszam +
              ", " +
              formData.TelepitesiCim +
              " " +
              formData.TelepitesiUtcahazszam,
            nettovallalkozoidij: arformazo(nettovallalkozoidij),
            afa: arformazo(afa),
            garanciak: newGaranciak,
            bruttovallalkozoidij: arformazo(formData.bruttovallalkozoidij),
            elolegnetto: arformazo(elolegnetto),
            elolegafa: arformazo(elolegafa),
            elolegbrutto: arformazo(elolegbrutto),
            ertekesitonev: ertekesito.name,
            ertekesitotelefonszam: ertekesito.telefonszam,
            telefonszam: formData.telefonszam,
            email: formData.email,
            ertekesitoemail: ertekesito.email,
            keltezesvaros: formData.keltezesvaros,
            keltezesdatuma: formattedKeltezesdatuma,
            eloleg: formData.eloleg,
          },
          file: "",
          sheet: "",
          name: "",
          output_name:
            formData.nev !== "" && formData.nev != null
              ? formData.nev
              : "vallalkozasi_szerzodes",
          output_format: ".pdf",
          output_quality: 100,
          single_file: true,
          page_break: true,
          merge_with: "",
        };
        fetch("https://api.docugenerate.com/v1/document", {
          method: "POST",
          headers: {
            accept: "application/json",
            Authorization: "945c5c49b7f73ff286550a920c167eba",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(jsonData),
        })
          .then((response) => response.json())
          .then((data) => {
            if (downloadDocument) {
              window.location.href = data.document_uri;
            }
            const documentUri = data.document_uri;
            setLoading(true);
            setMainButtonLoading(true);
            setSuccess(false);
            setError(false);

            const userParams = new URLSearchParams({
              Name: formData.nev,
              CategoryId: 56,
            });

            fetch(
              `${
                config.API_URL_ONRENDER
              }/minicrm/smallUser?${userParams.toString()}`,
              {
                method: "GET",
                headers: {
                  accept: "application/json",
                  Authorization: `Bearer ${localStorage.token}`,
                },
              }
            )
              .then((response) => response.json())
              .then((user) => {
                const params = new URLSearchParams({
                  id: user.Id,
                });

                const requestBody = {
                  File2584: documentUri,
                  KikuldesDatuma: new Date().toISOString(),
                  StatusId: 3457,
                };

                fetch(
                  `${
                    config.API_URL_ONRENDER
                  }/minicrm/uploadFile?${params.toString()}`,
                  {
                    method: "PUT",
                    headers: {
                      accept: "application/json",
                      Authorization: `Bearer ${localStorage.token}`,
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                  }
                )
                  .then((response) => {
                    if (!response.ok) {
                      return response.json().then((error) => {
                        throw new Error(error.message || "Unknown error");
                      });
                    }
                    return response.json();
                  })
                  .then(() => {
                    setSuccess(true);
                    setLoading(false);
                    setMainButtonLoading(false);
                  })
                  .catch((error) => {
                    setError(true);
                    setLoading(false);
                    setMainButtonLoading(false);
                    console.error("Error:", error);
                  });
              })
              .catch((error) => {
                setError(true);
                setLoading(false);
                setMainButtonLoading(false);
                console.error("Error:", error);
              });
          })
          .catch((error) => {
            setError(true);
            setLoading(false);
            setMainButtonLoading(false);
            console.error("Error:", error);
          });
      },
    });
  };

  const [downloadDocument, setDownloadDocument] = useState(false);

  const handleCheckboxChange = (event) => {
    setDownloadDocument(event.target.checked);
  };

  const handleCheckboxAlairasChange = (e) => {
    const { name } = e.target;
    console.log(name, e.target.checked);

    setFormData({ ...formData, [name]: e.target.checked });
  };

  const handleButtonClick = () => {
    setMainButtonLoading(false);
    setLoading(true);
    setSuccess(false);
    setError(false);

    const params = new URLSearchParams({
      CategoryId: 55,
    });
    if (kitoltotteNev) {
      params.append("Name", formData.ugyfelnev);
    } else if (kitoltotteId) {
      params.append("Id", formData.Id);
    }

    fetch(`${config.API_URL_ONRENDER}/minicrm/fullUser?${params.toString()}`, {
      method: "GET",
      headers: {
        accept: "application/json",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setSuccess(true);
        setLoading(false);

        // Check if there are multiple keys in the returned object
        if (Object.keys(data).length >= 1) {
          const azertekesito = Object.entries(employees).find(
            ([key, value]) => {
              return value.name === data.UserId;
            }
          );
          setNevOptions([]);
          setFormData((prevFormData) => ({
            ...prevFormData,
            nev: data.Name,
            telefonszam: data.Phone,
            email: data.Email,
            lakcim:
              data.LakcimIranyitoszam +
              ", " +
              data.Lakcim +
              " " +
              data.LakcimUtcahazszam,
            szuletesihely: data.SzuletesiHelyIdo,
            szuletesiido: new Date(data.SzuletesiIdo2),
            anyjaneve: data.AnyjaNeve,
            adoazonosito: data.AdoazonositoJel,
            telepiteshelye:
              data.TelepitesiIranyitoszam +
              ", " +
              data.TelepitesiCim +
              " " +
              data.TelepitesiUtcahazszam,
            bruttovallalkozoidij: data.Float2427,
            keltezesvaros: data.TelepitesiCim,
            ertekesito:
              azertekesito && azertekesito.length > 1
                ? JSON.stringify(azertekesito[1])
                : "",
            eloleg: 50,
            NevlegesTeljesitmeny: data.NevlegesTeljesitmeny,
            napelemtipus: data.Napelempanel,
            napelemdarab: parseInt(data.PanelDarabszam),
            invertertipus: data.Inverter,
            inverterdarab: parseInt(data.InverterDarabszam),
            akkumulatortipus: data.Energiatarolo3,
            akkumulatordarab: parseInt(data.EnergiataroloDarabszam),
            TelepitesiCim: data.TelepitesiCim,
            TelepitesiIranyitoszam: data.TelepitesiIranyitoszam,
            TelepitesiUtcahazszam: data.TelepitesiUtcahazszam,
            Id: data.Id,
            ContactId: data.ContactId,
          }));
          if (selectedJson === "atadas") {
            const userParams = new URLSearchParams({
              Name: data.Name,
              CategoryId: 63,
            });

            if (data.Name) {
              fetch(
                `${
                  config.API_URL_ONRENDER
                }/minicrm/smallUser?${userParams.toString()}`,
                {
                  method: "GET",
                  headers: {
                    accept: "application/json",
                    Authorization: `Bearer ${localStorage.token}`,
                  },
                }
              )
                .then((response) => response.json())
                .then((user) => {
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    bekuldeniId: user.Id,
                  }));
                })
                .catch((error) => {
                  setError(true);
                  setLoading(false);
                  setMainButtonLoading(false);
                  console.error("Error:", error);
                });
            }
          }
          setLoading(false);
          setSuccess(true);
          setError(false);
        } else {
          setNevOptions([]);
        }
      })
      .catch((error) => {
        setError(true);
        setLoading(false);
        console.error("Error:", error);
      });
  };

  const handleAddressButtonClick = () => {
    setLoading(true);
    setSuccess(false);
    setError(false);

    const params = new URLSearchParams({
      id: formData.selectedKey,
    });

    fetch(`${config.API_URL_ONRENDER}/minicrm/address?${params.toString()}`, {
      method: "GET",
      headers: {
        accept: "application/json",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setSuccess(true);
        setLoading(false);

        // Check if there are multiple keys in the returned object
        if (Object.keys(data).length === 1) {
          const option = Object.values(data)[0];
          console.log(option, Object.values(data)[0]);
          setFormData((prevFormData) => ({
            ...prevFormData,
            lakcim: option,
          }));
        }
      })
      .catch((error) => {
        setError(true);
        setLoading(false);
        console.error("Error:", error);
      });
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} sx={{ mx: "auto", mb: "2rem" }}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Válassza ki az árajánlat típusát
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={selectedJson}
              label="Válassza ki a dokumentum típusát"
              onChange={handleJsonChange}>
              <MenuItem value="vallalkozasi">Vállalkozási</MenuItem>
              <MenuItem value="otthonfelujitasi">Otthonfelújítási</MenuItem>
              <MenuItem value="atadas">Átadás-átvételi</MenuItem>
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      {selectedJson === "vallalkozasi" ? (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} sx={{ mx: "auto", mb: "2rem" }}>
              <TextField
                autoComplete="Id"
                name="Id"
                required
                disabled={kitoltotteNev}
                fullWidth
                id="Id"
                label="Ügyfél ID"
                autoFocus
                value={formData.Id}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={6}>
              {nevOptions.length > 1 ? (
                <FormControl fullWidth>
                  <InputLabel>Név</InputLabel>
                  <Select
                    name="nev"
                    disabled={kitoltotteId}
                    value={formData.nev}
                    onChange={handleChange}>
                    {nevOptions.map((option, index) => (
                      <MenuItem key={index} value={option.Name}>
                        {option.Name} ({option.Id})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <TextField
                  name="nev"
                  label="Név"
                  fullWidth
                  value={formData.nev}
                  onChange={handleChange}
                />
              )}
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="telefonszam"
                label="Telefonszám"
                fullWidth
                value={formData.telefonszam}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="email"
                label="E-mail cím"
                fullWidth
                value={formData.email}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="lakcim"
                label="Lakcím"
                fullWidth
                value={formData.lakcim}
                onChange={handleChange}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                justifyContent: "center",
                display: "flex",
                flexWrap: "wrap",
                rowGap: 2,
                columnGap: 5,
              }}>
              <Button
                variant="contained"
                color="primary"
                disabled={isButtonDisabled || isLoading}
                onClick={handleButtonClick}>
                {isLoading ? (
                  <CircularProgress size={24} />
                ) : (
                  "Felhasználó keresése"
                )}
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={isButtonDisabled || isLoading}
                onClick={() => {
                  setFormData(defaultFormData);
                  setKitoltotteId(false);
                  setKitoltotteNev(false);
                  setNevOptions([]);
                }}>
                Törlés
              </Button>
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="szuletesihely"
                label="Születési hely"
                fullWidth
                value={formData.szuletesihely}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <DatePicker
                name="szuletesiido"
                label="Születési idő"
                value={formData.szuletesiido}
                onChange={(date) => handleDateChange("szuletesiido", date)}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="anyjaneve"
                label="Anyja neve"
                fullWidth
                value={formData.anyjaneve}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="adoazonosito"
                label="Adóazonosító"
                fullWidth
                value={formData.adoazonosito}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={9} lg={10}>
              <FormControl fullWidth>
                <InputLabel>Napelem típus</InputLabel>
                <Select
                  name="napelemtipus"
                  value={formData.napelemtipus}
                  onChange={handleChange}>
                  {arak.napelemek.map((napelem, index) => (
                    <MenuItem key={index} value={napelem.nev}>
                      {napelem.nev}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} lg={2}>
              <TextField
                name="napelemdarab"
                label="Napelem darab"
                type="number"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">db</InputAdornment>
                  ),
                }}
                value={formData.napelemdarab}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={9} lg={10}>
              <FormControl fullWidth>
                <InputLabel>Akkumulátor típus</InputLabel>
                <Select
                  name="akkumulatortipus"
                  value={formData.akkumulatortipus}
                  onChange={handleChange}>
                  {arak.akkumulatorok.map((akkumulator, index) => (
                    <MenuItem key={index} value={akkumulator.nev}>
                      {akkumulator.nev}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} lg={2}>
              <TextField
                name="akkumulatordarab"
                label="Akkumulátor darab"
                type="number"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">db</InputAdornment>
                  ),
                }}
                value={formData.akkumulatordarab}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={9} lg={10}>
              <FormControl fullWidth>
                <InputLabel>Inverter típus</InputLabel>
                <Select
                  name="invertertipus"
                  value={formData.invertertipus}
                  onChange={handleChange}>
                  {arak.inverterek.map((inverter, index) => (
                    <MenuItem key={index} value={inverter.nev}>
                      {inverter.nev}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} lg={2}>
              <TextField
                name="inverterdarab"
                label="Inverter darab"
                type="number"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">db</InputAdornment>
                  ),
                }}
                fullWidth
                value={formData.inverterdarab}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="bruttovallalkozoidij"
                label="Bruttó vállalkozói díj"
                type="number"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">ft</InputAdornment>
                  ),
                }}
                value={formData.bruttovallalkozoidij}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl fullWidth>
                <InputLabel>Előleg</InputLabel>
                <Select
                  name="eloleg"
                  value={formData.eloleg}
                  onChange={handleChange}>
                  <MenuItem value={10}>10%</MenuItem>
                  <MenuItem value={20}>20%</MenuItem>
                  <MenuItem value={30}>30%</MenuItem>
                  <MenuItem value={40}>40%</MenuItem>
                  <MenuItem value={50}>50%</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="TelepitesiIranyitoszam"
                label="Telepítés Irányítószám"
                fullWidth
                value={formData.TelepitesiIranyitoszam}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="TelepitesiCim"
                label="Telepítés Város"
                fullWidth
                value={formData.TelepitesiCim}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="TelepitesiUtcahazszam"
                label="Telepítés Utca, Házszám"
                fullWidth
                value={formData.TelepitesiUtcahazszam}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={4} lg={6}>
              <DatePicker
                name="keltezesdatuma"
                label="Keltezés dátuma"
                value={formData.keltezesdatuma}
                onChange={(date) => handleDateChange("keltezesdatuma", date)}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </Grid>
            <Grid item xs={8} lg={6}>
              <TextField
                name="keltezesvaros"
                label="Keltezés városa"
                fullWidth
                value={formData.keltezesvaros}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <FormControl fullWidth>
                <InputLabel>Értékesítő</InputLabel>
                <Select
                  name="ertekesito"
                  value={formData.ertekesito}
                  onChange={handleChange}>
                  {Object.entries(employees)
                    .filter(([key, value]) => value.name) // Filter out employees without a name property
                    .map(([key, value]) => (
                      <MenuItem key={key} value={JSON.stringify(value)}>
                        {value.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                style={{ float: "left" }}
                control={
                  <Checkbox
                    checked={downloadDocument}
                    onChange={handleCheckboxChange}
                    color="primary"
                  />
                }
                label="Dokumentumok letöltése"
              />
            </Grid>
            <Grid item xs={12} style={{ paddingTop: "12px" }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isLoading && isMainButtonLoading}>
                {isLoading && isMainButtonLoading ? (
                  <CircularProgress size={24} />
                ) : isSuccess ? (
                  "Sikeres generálás"
                ) : isError ? (
                  "Hiba!"
                ) : (
                  "Generálás"
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      ) : selectedJson === "atadas" ? (
        <form onSubmit={handleSubmitAtadas}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} sx={{ mx: "auto", mb: "2rem" }}>
              <TextField
                autoComplete="Id"
                name="Id"
                required
                disabled={kitoltotteNev}
                fullWidth
                id="Id"
                label="Ügyfél ID"
                autoFocus
                value={formData.Id}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ justifyContent: "center" }}>
            <Grid item xs={12} lg={6}>
              {nevOptions.length > 1 ? (
                <FormControl fullWidth>
                  <InputLabel>Név</InputLabel>
                  <Select
                    name="nev"
                    disabled={kitoltotteId}
                    value={formData.nev}
                    onChange={handleChange}>
                    {nevOptions.map((option, index) => (
                      <MenuItem key={index} value={option.Name}>
                        {option.Name} ({option.Id})
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                <TextField
                  name="nev"
                  label="Név"
                  fullWidth
                  disabled={kitoltotteId}
                  value={formData.nev}
                  onChange={handleChange}
                />
              )}
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="telefonszam"
                label="Telefonszám"
                fullWidth
                value={formData.telefonszam}
                onChange={handleChange}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                justifyContent: "center",
                display: "flex",
                flexWrap: "wrap",
                rowGap: 2,
                columnGap: 5,
              }}>
              <Button
                variant="contained"
                color="primary"
                disabled={isButtonDisabled || isLoading}
                onClick={handleButtonClick}>
                {isLoading ? (
                  <CircularProgress size={24} />
                ) : (
                  "Felhasználó keresése"
                )}
              </Button>
              <Button
                variant="contained"
                color="primary"
                disabled={isButtonDisabled || isLoading}
                onClick={() => {
                  setFormData(defaultFormData);
                  setKitoltotteId(false);
                  setKitoltotteNev(false);
                  setNevOptions([]);
                }}>
                Törlés
              </Button>
            </Grid>

            <Grid item xs={12} lg={6}>
              <TextField
                name="email"
                label="E-mail cím"
                fullWidth
                value={formData.email}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="TelepitesiIranyitoszam"
                label="Telepítés Irányítószám"
                fullWidth
                value={formData.TelepitesiIranyitoszam}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="TelepitesiCim"
                label="Telepítés Város"
                fullWidth
                value={formData.TelepitesiCim}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="TelepitesiUtcahazszam"
                label="Telepítés Utca, Házszám"
                fullWidth
                value={formData.TelepitesiUtcahazszam}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="szuletesihely"
                label="Születési hely"
                fullWidth
                value={formData.szuletesihely}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <DatePicker
                name="szuletesiido"
                label="Születési idő"
                value={formData.szuletesiido}
                onChange={(date) => handleDateChange("szuletesiido", date)}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </Grid>
            <Grid item xs={12} lg={6}>
              <TextField
                name="anyjaneve"
                label="Anyja neve"
                fullWidth
                value={formData.anyjaneve}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} lg={6}>
              <TextField
                name="NevlegesTeljesitmeny"
                label="Névleges teljesítmény"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">kWh</InputAdornment>
                  ),
                }}
                value={parseFloat(formData.NevlegesTeljesitmeny).toString()}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={9} lg={10}>
              <FormControl fullWidth>
                <InputLabel>Napelem típus</InputLabel>
                <Select
                  name="napelemtipus"
                  value={formData.napelemtipus}
                  onChange={handleChange}>
                  {arak.napelemek.map((napelem, index) => (
                    <MenuItem key={index} value={napelem.nev}>
                      {napelem.nev}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} lg={2}>
              <TextField
                name="napelemdarab"
                label="Napelem darab"
                type="number"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">db</InputAdornment>
                  ),
                }}
                value={formData.napelemdarab}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={9} lg={10}>
              <FormControl fullWidth>
                <InputLabel>Akkumulátor típus</InputLabel>
                <Select
                  name="akkumulatortipus"
                  value={formData.akkumulatortipus}
                  onChange={handleChange}>
                  {arak.akkumulatorok.map((akkumulator, index) => (
                    <MenuItem key={index} value={akkumulator.nev}>
                      {akkumulator.nev}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} lg={2}>
              <TextField
                name="akkumulatordarab"
                label="Akkumulátor darab"
                type="number"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">db</InputAdornment>
                  ),
                }}
                value={formData.akkumulatordarab}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={9} lg={10}>
              <FormControl fullWidth>
                <InputLabel>Inverter típus</InputLabel>
                <Select
                  name="invertertipus"
                  value={formData.invertertipus}
                  onChange={handleChange}>
                  {arak.inverterek.map((inverter, index) => (
                    <MenuItem key={index} value={inverter.nev}>
                      {inverter.nev}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3} lg={2}>
              <TextField
                name="inverterdarab"
                label="Inverter darab"
                type="number"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">db</InputAdornment>
                  ),
                }}
                fullWidth
                value={formData.inverterdarab}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6} lg={6}>
              <DatePicker
                name="keltezesdatuma"
                label="Keltezés dátuma"
                value={formData.keltezesdatuma}
                onChange={(date) => handleDateChange("keltezesdatuma", date)}
                renderInput={(params) => <TextField {...params} fullWidth />}
              />
            </Grid>
            <Grid item xs={6} lg={6}>
              <TextField
                name="keltezesvaros"
                label="Keltezés városa"
                fullWidth
                value={formData.keltezesvaros}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6} lg={6}>
              <TextField
                name="keltezesvaros"
                label="Keltezés városa"
                fullWidth
                value={formData.keltezesvaros}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6} lg={6}>
              <TextField
                name="bekuldeniId"
                label="Beküldeni ID"
                fullWidth
                value={formData.bekuldeniId}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControlLabel
                style={{ float: "left" }}
                control={
                  <Checkbox
                    checked={downloadDocument}
                    onChange={handleCheckboxChange}
                    color="primary"
                  />
                }
                label="Dokumentumok letöltése"
              />
            </Grid>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description">
              <Box sx={style}>
                <Button onClick={handleClose} style={{ float: "right" }}>
                  X
                </Button>
                {currentScreen === 1 ? (
                  <div>
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2">
                      Beleegyzeés
                    </Typography>
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              style={{
                                transform: "scale(2)",
                              }}
                              name="napelemAtveszem"
                              checked={formData.napelemAtveszem}
                              onChange={handleCheckboxAlairasChange}
                            />
                          }
                          style={{ paddingLeft: "12px" }}
                          label="A próbaműködés során a napelemes rendszer megfelelően működött, próbaüzemben átveszem."
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              style={{
                                transform: "scale(2)",
                              }}
                              name="akkumulatorAtveszem"
                              checked={formData.akkumulatorAtveszem}
                              onChange={handleCheckboxAlairasChange}
                            />
                          }
                          style={{ paddingLeft: "12px" }}
                          label="A próbaműködés során az akkumulátor/ok megfelelően működött/tek, próbaüzemben átveszem."
                        />
                      </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      <Grid item xs={6}>
                        <Button
                          className="second-button"
                          variant="contained"
                          color="secondary"
                          onClick={handleClose}>
                          BEZÁRÁS
                        </Button>
                      </Grid>
                      <Grid item xs={6} style={{ textAlign: "right" }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleNext}>
                          Tovább
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  <div>
                    <Typography
                      id="modal-modal-title"
                      variant="h6"
                      component="h2">
                      Aláírás
                    </Typography>
                    <div
                      id="modal-modal-description"
                      style={{
                        marginTop: "12px",
                        height: "77vh",
                        position: "relative",
                      }}>
                      <SignaturePad
                        penColor="blue"
                        velocityFilterWeight={0.2}
                        canvasProps={{
                          className: "signatureCanvas",
                        }}
                        ref={sigCanvas}
                      />
                    </div>
                    <Grid container spacing={2} sx={{ mt: 2 }}>
                      <Grid item xs={4}>
                        <Button
                          className="second-button"
                          variant="contained"
                          color="secondary"
                          onClick={handleBack}>
                          VISSZA
                        </Button>
                      </Grid>
                      <Grid item xs={4} style={{ textAlign: "center" }}>
                        <Button
                          className="second-button"
                          variant="contained"
                          color="secondary"
                          onClick={clearSigpad}>
                          Törlés
                        </Button>
                      </Grid>
                      <Grid item xs={4} sx={{ textAlign: "right" }}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleFinish}>
                          KÉSZ
                        </Button>
                      </Grid>
                    </Grid>
                  </div>
                )}
              </Box>
            </Modal>
            <Grid item xs={12} lg={4} style={{ paddingTop: "12px" }}>
              <Button
                type="button"
                variant="contained"
                color="primary"
                style={{ width: "100%" }}
                onClick={(e) => {
                  handleOpen(e);
                }}>
                Aláírás
              </Button>
            </Grid>
            <Grid item xs={12} lg={8} style={{ paddingTop: "12px" }}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{ width: "100%" }}
                disabled={(isLoading && isMainButtonLoading) || !vanAlairas}>
                {isLoading && isMainButtonLoading ? (
                  <CircularProgress size={24} />
                ) : isSuccess ? (
                  "Sikeres generálás"
                ) : isError ? (
                  "Hiba!"
                ) : (
                  "Generálás"
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      ) : (
        <OtthonFelujitas />
      )}
    </LocalizationProvider>
  );
};

export default DokumentumKitolto;
